import { ReportField, SortField } from "../../../shared/reporting/api/biClient.types";

export const getSortField = (field: ReportField, sorts: SortField[]) => {
  return sorts.find((s) => s.config.id === field.config.guid);
};
